import { getChildEdgeTypeId } from '@iotv/datamodel';
import { AdjacentType } from '@iotv/iotv-v3-types';
import { getIconForType } from '../../../Iconography';
import { DefaultLabelClickWrapper, DefaultStepTypeFolderClickWrapper } from '../../../v2/components/generic/ObjectTree/componentWrappers';
/** returns recursive query path of grouper type and one contained type which will produce a nested tree structure.
 * As a grouper type is required to start the path, and that seed grouper needs the contained items path, both the recursive path and the contained items path are
 * returned. Both should be used in the nextSteps of the consuming query
 */
export const getSingleTypeRecursivePath = ({ groupObjectType, GroupTypeClickWrapper, GroupInstanceClickWrapper, containedObjectType, ContainedTypeLabelWrapper, ContainedTypeInstanceClickWrapper, }) => {
    const subGroupEdgeTypeId = getChildEdgeTypeId(groupObjectType, groupObjectType); // LIMITATION only take the edge type if one is defined
    const subGroupTypeNode = {
        stepQuery: {
            objectTypeId: groupObjectType,
            edgeTypeId: subGroupEdgeTypeId,
            adjacencyType: AdjacentType.CHILD, // ASSUMPTION grouping sub types are child relationships
        },
        endIcon: getIconForType(groupObjectType),
        nextSteps: [],
        // itemDerivedControls: () => <div>{ groupObjectType }</div>,
        renderTypeFolder: false,
        thisStepLabelWrapper: GroupInstanceClickWrapper ?? DefaultLabelClickWrapper,
        thisStepTypeFolderClickWrapper: GroupTypeClickWrapper ?? DefaultStepTypeFolderClickWrapper,
    };
    const containedEdgeTypeId = getChildEdgeTypeId(groupObjectType, containedObjectType); // LIMITATION only take the edge type if one is defined
    const containedTypeNode = {
        stepQuery: {
            edgeTypeId: containedEdgeTypeId,
            objectTypeId: containedObjectType,
            adjacencyType: AdjacentType.CHILD, // LIMITATION contained type must have child relationship with grouping type
        },
        endIcon: getIconForType(containedObjectType),
        nextSteps: [],
        // itemDerivedControls: () => <div>{ containedObjectType  }</div>,
        renderTypeFolder: false,
        thisStepLabelWrapper: ContainedTypeInstanceClickWrapper ?? DefaultLabelClickWrapper,
        thisStepTypeFolderClickWrapper: ContainedTypeLabelWrapper ?? DefaultStepTypeFolderClickWrapper,
    };
    subGroupTypeNode.nextSteps.push(subGroupTypeNode, containedTypeNode);
    return [subGroupTypeNode, containedTypeNode];
};
